// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1cb2d1e2","453":"a9a83924","455":"08f6c8b6"}[chunkId] + ".chunk.js";
};